<template>
  <div class="app-wrapper">
    <HeaderView/>
    <main class="app-main">
      <router-view/>
    </main>
    <FooterView/>
  </div>
</template>
<script setup>
import HeaderView from "./views/HeaderView.vue";
import FooterView from "./views/FooterView.vue";

</script>
<style>
html {
  font-size: max(15px, 2vh);
  user-select: none;
  overflow-x: hidden;
}

body {
  font-size: 1rem;
  overflow-x: hidden;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
  cursor: auto;
}

.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-main {
  flex: 1;
}
</style>